import React from "react";
import "./Soon.css";

function Soon() {
  return (
    <div className="Soon-bdy">
      <div className="Soon-content">
        <a href="https://linkedin.com/company/sk-air/">
          <button className="Soon-btn">More Informations</button>
        </a>
      </div>
    </div>
  );
}

export default Soon;
